// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root,
[data-theme='light'] {
  --color-primary: #ffffff;
  --color-secondary: #a62c21;
  --color-tertiary: #eef1f6;
  --color-neutral: #f0f2f5;
  --color-surface: #ffffff;
  --color-surface-raised: #ffffff;
  --color-border: #d8dee6;
  --color-text: #1a2332;
  --color-text-muted: #5c6778;
  --color-accent: #3b7fc4;
  --color-accent-soft: rgba(59, 127, 196, 0.12);
  --color-on-accent: #ffffff;
  --color-hover-overlay: rgba(0, 0, 0, 0.04);
  --color-backdrop: rgba(15, 23, 42, 0.45);
  --color-danger-soft: rgba(166, 44, 33, 0.1);
  --color-danger-subtle: rgba(166, 44, 33, 0.08);
  --color-warning: #b8860b;
  --color-warning-soft: rgba(184, 134, 11, 0.12);
  --color-warning-subtle: rgba(184, 134, 11, 0.1);
  --color-muted-soft: rgba(92, 103, 120, 0.12);
  --color-rdt-highlight: rgba(59, 127, 196, 0.14);
  --color-rdt-striped: rgba(0, 0, 0, 0.02);
  --color-rdt-btn-hover: rgba(0, 0, 0, 0.05);
  --color-rdt-scrollbar-hover: rgba(0, 0, 0, 0.2);
  --color-theme-toggle-bg: #e4e8ef;
  --color-theme-toggle-border: rgba(26, 35, 50, 0.08);
  --color-theme-toggle-icon: #5c6778;
  --color-theme-toggle-icon-active: #ffffff;
  --color-theme-toggle-hover: rgba(26, 35, 50, 0.06);
  --color-theme-toggle-active: #ffffff;
  --color-sidebar: #121f3a;
  --color-sidebar-border: #243247;
  --color-sidebar-text: #f0f2f5;
  --color-sidebar-text-muted: #9aa3b2;
  --color-sidebar-hover: rgba(255, 255, 255, 0.06);
  --color-sidebar-surface: rgba(255, 255, 255, 0.06);
  --color-btn: #121f3a;
  --color-btn-hover: #1a2a47;
  --color-btn-danger: #801414;
  --color-btn-danger-hover: #961818;
  --color-btn-text: #ffffff;
  --color-icon: #ffffff;
  --sidebar-width: 240px;
  --header-height: 64px;
  --radius: 12px;
  --shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}

[data-theme='dark'] {
  --color-primary: #0a1d37;
  --color-secondary: #a62c21;
  --color-tertiary: #1e2a3b;
  --color-neutral: #0d0d0d;
  --color-surface: #141414;
  --color-surface-raised: #1e2a3b;
  --color-border: #2a3545;
  --color-text: #f0f2f5;
  --color-text-muted: #9aa3b2;
  --color-accent: #4a8fd4;
  --color-accent-soft: rgba(74, 143, 212, 0.15);
  --color-on-accent: #ffffff;
  --color-hover-overlay: rgba(255, 255, 255, 0.06);
  --color-backdrop: rgba(0, 0, 0, 0.55);
  --color-danger-soft: rgba(166, 44, 33, 0.12);
  --color-danger-subtle: rgba(166, 44, 33, 0.08);
  --color-warning: #b8860b;
  --color-warning-soft: rgba(184, 134, 11, 0.15);
  --color-warning-subtle: rgba(184, 134, 11, 0.1);
  --color-muted-soft: rgba(154, 163, 178, 0.15);
  --color-rdt-highlight: rgba(74, 143, 212, 0.18);
  --color-rdt-striped: rgba(255, 255, 255, 0.03);
  --color-rdt-btn-hover: rgba(255, 255, 255, 0.08);
  --color-rdt-scrollbar-hover: rgba(255, 255, 255, 0.25);
  --color-theme-toggle-bg: #2a3545;
  --color-theme-toggle-border: rgba(255, 255, 255, 0.08);
  --color-theme-toggle-icon: #9aa3b2;
  --color-theme-toggle-icon-active: #ffffff;
  --color-theme-toggle-hover: rgba(255, 255, 255, 0.06);
  --color-theme-toggle-active: #1e2a3b;
  --color-sidebar: #121f3a;
  --color-sidebar-border: #243247;
  --color-sidebar-text: #f0f2f5;
  --color-sidebar-text-muted: #9aa3b2;
  --color-sidebar-hover: rgba(255, 255, 255, 0.06);
  --color-sidebar-surface: rgba(255, 255, 255, 0.06);
  --color-btn: #121f3a;
  --color-btn-hover: #1a2a47;
  --color-btn-danger: #801414;
  --color-btn-danger-hover: #961818;
  --color-btn-text: #ffffff;
  --color-icon: #ffffff;
  --shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html,
body,
#root {
  height: 100%;
  min-height: 100%;
}

body {
  margin: 0;
  overflow: hidden;
  font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: var(--color-neutral);
  color: var(--color-text);
}

button {
  font: inherit;
}

a {
  color: inherit;
  text-decoration: none;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

.app-icon {
  display: block;
  width: 100%;
  height: 100%;
  color: var(--color-icon);
}

.Toastify__toast-theme--dark,
.Toastify__toast-theme--light {
  background: var(--color-surface-raised);
  color: var(--color-text);
  border: 1px solid var(--color-border);
}

.Toastify__toast-theme--dark .Toastify__progress-bar,
.Toastify__toast-theme--light .Toastify__progress-bar {
  background: var(--color-accent);
}

.Toastify__toast-theme--dark .Toastify__close-button,
.Toastify__toast-theme--light .Toastify__close-button {
  color: var(--color-text-muted);
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;EAEE,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;EACxB,wBAAwB;EACxB,+BAA+B;EAC/B,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;EAC3B,uBAAuB;EACvB,6CAA6C;EAC7C,0BAA0B;EAC1B,0CAA0C;EAC1C,wCAAwC;EACxC,2CAA2C;EAC3C,8CAA8C;EAC9C,wBAAwB;EACxB,8CAA8C;EAC9C,+CAA+C;EAC/C,4CAA4C;EAC5C,+CAA+C;EAC/C,wCAAwC;EACxC,0CAA0C;EAC1C,+CAA+C;EAC/C,gCAAgC;EAChC,mDAAmD;EACnD,kCAAkC;EAClC,yCAAyC;EACzC,kDAAkD;EAClD,oCAAoC;EACpC,wBAAwB;EACxB,+BAA+B;EAC/B,6BAA6B;EAC7B,mCAAmC;EACnC,gDAAgD;EAChD,kDAAkD;EAClD,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,iCAAiC;EACjC,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;EACxB,wBAAwB;EACxB,+BAA+B;EAC/B,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;EAC3B,uBAAuB;EACvB,6CAA6C;EAC7C,0BAA0B;EAC1B,gDAAgD;EAChD,qCAAqC;EACrC,4CAA4C;EAC5C,8CAA8C;EAC9C,wBAAwB;EACxB,8CAA8C;EAC9C,+CAA+C;EAC/C,6CAA6C;EAC7C,+CAA+C;EAC/C,8CAA8C;EAC9C,gDAAgD;EAChD,sDAAsD;EACtD,gCAAgC;EAChC,sDAAsD;EACtD,kCAAkC;EAClC,yCAAyC;EACzC,qDAAqD;EACrD,oCAAoC;EACpC,wBAAwB;EACxB,+BAA+B;EAC/B,6BAA6B;EAC7B,mCAAmC;EACnC,gDAAgD;EAChD,kDAAkD;EAClD,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,iCAAiC;EACjC,yBAAyB;EACzB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;EAGE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB;qCACmC;EACnC,mCAAmC;EACnC,kCAAkC;EAClC,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;;EAEE,uCAAuC;EACvC,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,8BAA8B;AAChC","sourcesContent":[":root,\n[data-theme='light'] {\n  --color-primary: #ffffff;\n  --color-secondary: #a62c21;\n  --color-tertiary: #eef1f6;\n  --color-neutral: #f0f2f5;\n  --color-surface: #ffffff;\n  --color-surface-raised: #ffffff;\n  --color-border: #d8dee6;\n  --color-text: #1a2332;\n  --color-text-muted: #5c6778;\n  --color-accent: #3b7fc4;\n  --color-accent-soft: rgba(59, 127, 196, 0.12);\n  --color-on-accent: #ffffff;\n  --color-hover-overlay: rgba(0, 0, 0, 0.04);\n  --color-backdrop: rgba(15, 23, 42, 0.45);\n  --color-danger-soft: rgba(166, 44, 33, 0.1);\n  --color-danger-subtle: rgba(166, 44, 33, 0.08);\n  --color-warning: #b8860b;\n  --color-warning-soft: rgba(184, 134, 11, 0.12);\n  --color-warning-subtle: rgba(184, 134, 11, 0.1);\n  --color-muted-soft: rgba(92, 103, 120, 0.12);\n  --color-rdt-highlight: rgba(59, 127, 196, 0.14);\n  --color-rdt-striped: rgba(0, 0, 0, 0.02);\n  --color-rdt-btn-hover: rgba(0, 0, 0, 0.05);\n  --color-rdt-scrollbar-hover: rgba(0, 0, 0, 0.2);\n  --color-theme-toggle-bg: #e4e8ef;\n  --color-theme-toggle-border: rgba(26, 35, 50, 0.08);\n  --color-theme-toggle-icon: #5c6778;\n  --color-theme-toggle-icon-active: #ffffff;\n  --color-theme-toggle-hover: rgba(26, 35, 50, 0.06);\n  --color-theme-toggle-active: #ffffff;\n  --color-sidebar: #121f3a;\n  --color-sidebar-border: #243247;\n  --color-sidebar-text: #f0f2f5;\n  --color-sidebar-text-muted: #9aa3b2;\n  --color-sidebar-hover: rgba(255, 255, 255, 0.06);\n  --color-sidebar-surface: rgba(255, 255, 255, 0.06);\n  --color-btn: #121f3a;\n  --color-btn-hover: #1a2a47;\n  --color-btn-danger: #801414;\n  --color-btn-danger-hover: #961818;\n  --color-btn-text: #ffffff;\n  --color-icon: #ffffff;\n  --sidebar-width: 240px;\n  --header-height: 64px;\n  --radius: 12px;\n  --shadow: 0 8px 24px rgba(15, 23, 42, 0.08);\n}\n\n[data-theme='dark'] {\n  --color-primary: #0a1d37;\n  --color-secondary: #a62c21;\n  --color-tertiary: #1e2a3b;\n  --color-neutral: #0d0d0d;\n  --color-surface: #141414;\n  --color-surface-raised: #1e2a3b;\n  --color-border: #2a3545;\n  --color-text: #f0f2f5;\n  --color-text-muted: #9aa3b2;\n  --color-accent: #4a8fd4;\n  --color-accent-soft: rgba(74, 143, 212, 0.15);\n  --color-on-accent: #ffffff;\n  --color-hover-overlay: rgba(255, 255, 255, 0.06);\n  --color-backdrop: rgba(0, 0, 0, 0.55);\n  --color-danger-soft: rgba(166, 44, 33, 0.12);\n  --color-danger-subtle: rgba(166, 44, 33, 0.08);\n  --color-warning: #b8860b;\n  --color-warning-soft: rgba(184, 134, 11, 0.15);\n  --color-warning-subtle: rgba(184, 134, 11, 0.1);\n  --color-muted-soft: rgba(154, 163, 178, 0.15);\n  --color-rdt-highlight: rgba(74, 143, 212, 0.18);\n  --color-rdt-striped: rgba(255, 255, 255, 0.03);\n  --color-rdt-btn-hover: rgba(255, 255, 255, 0.08);\n  --color-rdt-scrollbar-hover: rgba(255, 255, 255, 0.25);\n  --color-theme-toggle-bg: #2a3545;\n  --color-theme-toggle-border: rgba(255, 255, 255, 0.08);\n  --color-theme-toggle-icon: #9aa3b2;\n  --color-theme-toggle-icon-active: #ffffff;\n  --color-theme-toggle-hover: rgba(255, 255, 255, 0.06);\n  --color-theme-toggle-active: #1e2a3b;\n  --color-sidebar: #121f3a;\n  --color-sidebar-border: #243247;\n  --color-sidebar-text: #f0f2f5;\n  --color-sidebar-text-muted: #9aa3b2;\n  --color-sidebar-hover: rgba(255, 255, 255, 0.06);\n  --color-sidebar-surface: rgba(255, 255, 255, 0.06);\n  --color-btn: #121f3a;\n  --color-btn-hover: #1a2a47;\n  --color-btn-danger: #801414;\n  --color-btn-danger-hover: #961818;\n  --color-btn-text: #ffffff;\n  --color-icon: #ffffff;\n  --shadow: 0 8px 24px rgba(0, 0, 0, 0.35);\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nhtml,\nbody,\n#root {\n  height: 100%;\n  min-height: 100%;\n}\n\nbody {\n  margin: 0;\n  overflow: hidden;\n  font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: var(--color-neutral);\n  color: var(--color-text);\n}\n\nbutton {\n  font: inherit;\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n.app-icon {\n  display: block;\n  width: 100%;\n  height: 100%;\n  color: var(--color-icon);\n}\n\n.Toastify__toast-theme--dark,\n.Toastify__toast-theme--light {\n  background: var(--color-surface-raised);\n  color: var(--color-text);\n  border: 1px solid var(--color-border);\n}\n\n.Toastify__toast-theme--dark .Toastify__progress-bar,\n.Toastify__toast-theme--light .Toastify__progress-bar {\n  background: var(--color-accent);\n}\n\n.Toastify__toast-theme--dark .Toastify__close-button,\n.Toastify__toast-theme--light .Toastify__close-button {\n  color: var(--color-text-muted);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
